export const colors = {
  none: '#D4EDFC',
  veryLow: '#72C5F7',
  low: '#20A1EF',
  medium: '#1C8FD4',
  high: '#0B79BB',
};
